import { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import {
  Container,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Row,
  Col,
  Table,
  Spinner,
  Card,
  CardBody,
} from "reactstrap";
import Link from "next/link";
import {
  MdGpsFixed,
  MdLocalShipping,
  MdOutlineAdd,
  MdPublic,
  MdToll,
} from "react-icons/md";
import { FaPlus } from "react-icons/fa";

//local imports
import classes from "@/styles/partners/partner.module.css";
import technologyPartners from "@/data/technology-partner.json";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
import { logo, smallLogo } from "@/utils/images";
import { partner as p } from "@/utils/content";
import IntegrationDetails from "./integration-details";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function PartnerDetails() {
  const router: any = useRouter();
  const { partner } = router.query;
  const tp = technologyPartners.find((t) => t.url === `/${partner}`);
  const fp = fulfillmentPartners.find((t) => t.url === `/${partner}`);
  const partnerDetails: any = tp ? tp : fp;
  const isMobile = useIsMobile();

  const content = p.en;
  const [open, setOpen] = useState<string>("1");
  const [open2, setOpen2] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  //@ts-ignore
  const toggle2 = (id) => {
    if (open2 === id) {
      //@ts-ignore
      setOpen2();
    } else {
      setOpen2(id);
    }
  };

  return (
    <div className={classes.container}>
      {!partnerDetails ? (
        <Spinner className="m-auto" animation="border" role="status"></Spinner>
      ) : (
        <>
          <div className={classes.hero}>
            <div>
              <Image
                className={`${isMobile ? "me-4" : "ms-5"} img-fluid`}
                src={isMobile ? smallLogo : logo}
                alt="ShipVista logo"
                height={80}
                width={isMobile ? 80 : 300}
              />
            </div>
            <div>
              <MdOutlineAdd className={`text-darkblue ${classes.plusIco}`} />
            </div>
            <div>
              <Image
                className={`img-fluid ${
                  isMobile ? `${classes.heroImg}` : "me-5"
                }`}
                src={partnerDetails.logoPath}
                alt={partnerDetails.name}
                height={150}
                width={250}
              />
            </div>
          </div>
          <div className={classes.main}>
            {tp && (
              <Container className="mt-4">
                <div className={isMobile ? "text-center" : ""}>
                  <h2 className={classes.heading}>
                    {content.about} {partnerDetails.name}
                  </h2>
                  <p className={classes.brief}>
                    {partnerDetails.brief ? partnerDetails.brief : "N/A"}
                  </p>
                  <h2 className={classes.heading2}>
                    {content.integrate}&nbsp;{partnerDetails.name}&nbsp;
                    {content.accountToShipvista}
                  </h2>
                </div>
                {
                  //@ts-ignore
                  <Accordion className="my-4" open={open} toggle={toggle}>
                    <AccordionItem>
                      <AccordionHeader targetId="1">
                        {content.requirement}
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <p className="fw-bold">
                          {content.integrationRequirements}
                        </p>
                        <ul>
                          {partnerDetails.requirements &&
                            partnerDetails.requirements.map((r: string) => {
                              return <li key={r}>{r}</li>;
                            })}
                        </ul>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2">
                        {content.connect}
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <p>
                          {content.followSteps}&nbsp;{partnerDetails.name}&nbsp;
                          {content.toShipVista}
                        </p>
                        <ol className={classes.ol}>
                          {partnerDetails.integrationSteps &&
                            partnerDetails.integrationSteps.map((i: any) => {
                              return (
                                <li key={i.id}>
                                  <p>{i.list}</p>
                                  {i.img && (
                                    <Image
                                      className={classes.listImg}
                                      src={i.img}
                                      alt={i.img}
                                      height={300}
                                      width={200}
                                    />
                                  )}
                                </li>
                              );
                            })}
                        </ol>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3">
                        {content.availableFeatures}
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <p>
                          {content.shipvistaIntegration}&nbsp;
                          {partnerDetails.name}&nbsp;{content.supports}
                        </p>
                        <p className="fw-bold mb-1">
                          {content.commonIntegrationFeatures}
                        </p>
                        <Table striped bordered hover>
                          <thead className="table-dark">
                            <tr>
                              <th className="w-75" scope="col">
                                {content.feature}
                              </th>
                              <th className="" scope="col">
                                {content.support}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerDetails.availableFeatures &&
                              partnerDetails.availableFeatures.map((f: any) => {
                                return (
                                  <tr key={f.name}>
                                    <td>{f.name}</td>
                                    <td>{f.supported}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>
                        <p className="fw-bold mb-1">
                          {content.shipvistaUpdate}
                        </p>
                        <Table striped bordered hover>
                          <thead className="table-dark">
                            <tr>
                              <th className="w-75 ">
                                {content.shipvista}&nbsp;{content.status}
                              </th>
                              <th className="">
                                {partnerDetails.name}&nbsp;{content.status}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerDetails.shipVistaStatus &&
                              partnerDetails.shipVistaStatus.map((f: any) => {
                                return (
                                  <tr key={f.name}>
                                    <td>{f.name}</td>
                                    <td>{f.status}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>
                        <p className="fw-bold mb-1">
                          {content.shipvistaUpdate}
                        </p>
                        <Table striped bordered hover>
                          <thead className="table-dark">
                            <tr>
                              <th className="w-75 ">{content.field}</th>
                              <th className="">{content.support}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerDetails.shipvistaUpdate &&
                              partnerDetails.shipvistaUpdate.map((f: any) => {
                                return (
                                  <tr key={f.name}>
                                    <td>{f.name}</td>
                                    <td>{f.status}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="4">
                        {content.additionalDetails}
                      </AccordionHeader>
                      <AccordionBody accordionId="4">
                        <ul>
                          <li>
                            <p className="text-decoration-underline">
                              {partnerDetails.additionalDetails
                                ? partnerDetails.additionalDetails
                                : "N/A"}
                            </p>
                          </li>
                        </ul>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="5">
                        {content.troubleshooting}
                      </AccordionHeader>
                      <AccordionBody accordionId="5">
                        <p>
                          {partnerDetails.troubleshooting
                            ? partnerDetails.troubleshooting
                            : "N/A"}
                        </p>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                }
              </Container>
            )}
            {fp && (
              <Container>
                <section className="my-5 pb-5">
                  <p className="fw-bold w-50 my-5 inter">
                    {content.shipVistaPartnerTitle(partnerDetails.name)}
                  </p>
                  <h2 className="lato">
                    {content.about}&nbsp;{partnerDetails.name}
                  </h2>
                  <p className="inter w-50">
                    {partnerDetails.about ? partnerDetails.about : "N/A"}
                  </p>
                </section>
                <section className="my-5">
                  <Row>
                    <Col xs={12} lg={6}>
                      <h2 className="lato mt-5 mb-3">
                        {partnerDetails.title1 ? partnerDetails.title1 : "N/A"}
                      </h2>
                      <p className="inter">
                        {partnerDetails.para1 ? partnerDetails.para1 : "N/A"}
                      </p>
                    </Col>
                    <Col
                      className="d-flex justify-content-center align-items-center"
                      xs={12}
                      lg={6}
                    >
                      <Image
                        src={partnerDetails.image1}
                        alt={partnerDetails.image1}
                        height={275}
                        width={270}
                      />
                    </Col>
                  </Row>
                </section>
                <section className="my-5 pt-5 pb-5">
                  <Row>
                    <Col xs={12} lg={6}>
                      <div className="mt-5 pt-3">
                        <Row>
                          <Col sx={6}>
                            <div className={`d-grid ${classes.cardGrid}`}>
                              <div
                                className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                              >
                                <MdToll />
                              </div>
                              <p className="ps-3 pt-2 mt-1">
                                {content.card1Title}
                              </p>
                            </div>
                          </Col>
                          <Col sx={6}>
                            <div className={`d-grid ${classes.cardGrid}`}>
                              <div
                                className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                              >
                                <MdGpsFixed />
                              </div>
                              <p className="ps-3 pt-2 mt-1">
                                {content.card2Title}
                              </p>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-5">
                          <Col sx={6}>
                            <div className={`d-grid ${classes.cardGrid}`}>
                              <div
                                className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                              >
                                <MdPublic />
                              </div>
                              <p className="ps-3">{content.card3Title}</p>
                            </div>
                          </Col>
                          <Col sx={6}>
                            <div className={`d-grid ${classes.cardGrid}`}>
                              <div
                                className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                              >
                                <MdLocalShipping />
                              </div>
                              <p className="ps-3 pt-2 mt-1">
                                {content.card4Title}
                              </p>
                            </div>
                          </Col>
                        </Row>
                        <p>{partnerDetails.para5 && partnerDetails.para5}</p>
                      </div>
                    </Col>
                    <Col xs={12} lg={6}>
                      <h2 className="lato">
                        {partnerDetails.title2 ? partnerDetails.title2 : "N/A"}
                      </h2>
                      <p className="inter">
                        {partnerDetails.para2 ? partnerDetails.para2 : "N/A"}
                      </p>
                      <ul>
                        {partnerDetails.list1 &&
                          partnerDetails.list1.map((l: string, i: number) => {
                            return (
                              <li key={i} className="inter fw-bold">
                                {l}
                              </li>
                            );
                          })}
                      </ul>
                      <p>{partnerDetails.para4 && partnerDetails.para4}</p>
                    </Col>
                  </Row>
                </section>
                <section className="my-5">
                  <div className={classes.bigCard}>
                    <h2 className="lato text-center m-t">
                      {partnerDetails.title3}
                    </h2>
                    <p className="inter text-center">{partnerDetails.para3}</p>
                    {partnerDetails.serviceCards && (
                      <Row className="mt-5">
                        {partnerDetails.serviceCards.map(
                          (
                            s: {
                              title: string;
                              desc: string;
                              link: string;
                            },
                            i: number
                          ) => {
                            return (
                              <Col key={i} xs={12} lg={4}>
                                <Link
                                  className={classes.link}
                                  href={`/partners${s.link}`}
                                >
                                  <Card className={classes.greenCard}>
                                    <CardBody>
                                      <h2 className={classes.blueCardHeading}>
                                        {s.title}
                                      </h2>
                                      <p className={classes.blueCardPara}>
                                        {s.desc}
                                      </p>
                                    </CardBody>
                                  </Card>
                                </Link>
                              </Col>
                            );
                          }
                        )}
                      </Row>
                    )}
                  </div>
                </section>
                <section className="pt-5 mb-5 border-top">
                  <Row>
                    <Col xs={12} lg={3}>
                      <h2 className="lato fw-normal pt-4">{content.faq}</h2>
                      <p className="inter">
                        {content.faqPara(partnerDetails.name)}
                      </p>
                    </Col>
                    <Col xs={12} lg={9}>
                      {partnerDetails.faqs && (
                        <>
                          <Accordion
                            className="my-4"
                            open={open2}
                            //@ts-ignore
                            toggle={toggle2}
                          >
                            {partnerDetails.faqs.map(
                              (
                                f: {
                                  title: string;
                                  desc: string;
                                },
                                i: string
                              ) => {
                                return (
                                  <AccordionItem key={i}>
                                    <AccordionHeader
                                      targetId={(i + 1).toString()}
                                    >
                                      {f.title}
                                    </AccordionHeader>
                                    <AccordionBody
                                      accordionId={(i + 1).toString()}
                                    >
                                      <p>{f.desc}</p>
                                    </AccordionBody>
                                  </AccordionItem>
                                );
                              }
                            )}
                          </Accordion>
                        </>
                      )}
                    </Col>
                  </Row>
                </section>
                <IntegrationDetails partnerDetails={partnerDetails} />
              </Container>
            )}
          </div>
        </>
      )}
    </div>
  );
}
